"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _part = _interopRequireDefault(require("../utils/part"));

/**
 * Vrati query part pro shodu.
 *
 * @param {string} fieldName
 * @param {*} value
 */
var equalToQuery = function equalToQuery(fieldName, value) {
  return value === undefined ? undefined : (0, _part.default)(fieldName, value);
};

var _default = equalToQuery;
exports.default = _default;